export default [
  {
    title: 'Weatherstack',
    url: 'https://weatherstack.com/',
  },
  {
    title: 'Mapbox',
    url: 'https://www.mapbox.com/',
  },
];
